import { render } from "./userLayout.vue?vue&type=template&id=53cf38be"
import script from "./userLayout.vue?vue&type=script&lang=js"
export * from "./userLayout.vue?vue&type=script&lang=js"

import exportComponent from "D:\\angren\\admit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__